export default "__VITE_ASSET__BAhX2GdD__"